import { baggagePersonalEffectsLookup as expenseLookup } from './claimCodeMapper';
function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const damagedExpenses = mapToDamagedExpenses(data);
  const baggageDelayExpenses = mapToBaggageDelayExpenses(data);
  return [...damagedExpenses, ...baggageDelayExpenses];
}

function mapToDamagedExpenses(data) {
  if (data.areYouClaimingForDamaged !== 'true' || data.additionalItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForDamaged.claimCode;
  const expenses = [];

  data.additionalItems.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayExpenses(data) {
  if (data.areYouClaimingForBaggageDelay !== 'true' || data.delayedLuggageExpenses.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
  const expenses = [];

  data.delayedLuggageExpenses.forEach(
    (item) => {
      const expense = mapCollisionDamageExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }

      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapCollisionDamageExpense(item, formData, claimCode) {
  return mapExpenseItem(item, item.dateOfExpenses, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.estimatedValue || !item.currentEstimated) {
    return null;
  }
  return {
    shortDescription: item.itemDescription,
    dateOfExpense: itemDate,
    clientCost: item.estimatedValue,
    currency: item.currentEstimated,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

function mapReimbursement(item, formData, claimCode) {
  if (!item || !item.howMuchReceivedReimbursement || !item.currentReceivedReimbursement || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhomReceivedReimbursement} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuchReceivedReimbursement * -1}`,
    currency: item.currentReceivedReimbursement,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggagePersonalEffectsDataMapper.js